export var SizeComp;
(function (SizeComp) {
    SizeComp[SizeComp["XS"] = 0] = "XS";
    SizeComp[SizeComp["SM"] = 1] = "SM";
    SizeComp[SizeComp["LG"] = 2] = "LG";
    SizeComp[SizeComp["2X"] = 3] = "2X";
    SizeComp[SizeComp["3X"] = 4] = "3X";
    SizeComp[SizeComp["5X"] = 5] = "5X";
    SizeComp[SizeComp["7X"] = 6] = "7X";
    SizeComp[SizeComp["10X"] = 7] = "10X";
    SizeComp[SizeComp["LGX"] = 8] = "LGX";
})(SizeComp || (SizeComp = {}));
export function getClass(size) {
    switch (size) {
        case SizeComp.XS:
            return 'XS';
        case SizeComp.SM:
            return 'SM';
        case SizeComp.LG:
            return 'LG';
        case SizeComp.LGX:
            return 'LGX';
        case SizeComp['2X']:
            return 'doubleX';
        case SizeComp['3X']:
            return 'tripleX';
        case SizeComp['5X']:
            return 'quintupleX';
        case SizeComp['7X']:
            return 'sevenTimesX';
        case SizeComp['10X']:
            return 'tenTimesX';
        default:
            return 'LGX';
    }
}
//# sourceMappingURL=size.js.map
